import {
  Typography,
  MenuItem,
  Grid,
  Box,
  TextField,
} from "@material-ui/core";
import { useFormikContext } from "formik";

import { TicketFormValues } from "../../../interface/formik/TicketFormValues";
import FormErrorMessage from "../../shared/form-error-message";
import FormSelect from "../../shared/form-select";
import PriceField from "../../shared/price-field";
import { useAppDispatch, useAppSelector } from "../../../hooks";
import { getUsers, setUsers } from "../../../store/userStore";
import FormDateTimePicker from "../../shared/form-date-time-picker";
import { useMemo } from "react";
import { User } from "../../../interface/api/User";
import { SetUsersAction } from "../../../interface/redux-types/SetUsersAction";
import userService from "../../../services/userService";

const UnitedSoilsInformation = () => {
  const users = useAppSelector(getUsers);
  const dispatch = useAppDispatch();

  const { handleChange, values, setFieldValue } =
    useFormikContext<TicketFormValues>();

  useMemo(() => {
    userService.getUsers().then((response) => {
      if (response.ok) {
        const users = response.data as User[];
        const setUsersAction: SetUsersAction = {
          users,
        };
        dispatch(setUsers(setUsersAction));
      }
    });
  }, []);

  return (
    <Box sx={{ marginBottom: "16px" }}>
      <Typography
        variant="h6"
        style={{ fontWeight: 600, textDecoration: "underline", marginBottom: 12 }}
      >
        UNITED SOILS
      </Typography>

      <Grid container spacing={2}>
        <Grid item xs={12}>
          <FormSelect
            name="userId"
            label={"Receiving Contact"}
            value={values.userId}
            items={[
              users.map((user, index) => (
                <MenuItem key={index} value={user.id}>
                  {user.firstName} {user.lastName}
                </MenuItem>
              )),
            ]}
          />
        </Grid>
        <Grid item xs={12}>
          <FormDateTimePicker
            label="Time Received"
            value={values.timeReceived ? new Date(values.timeReceived) : null}
            onChange={(date: any) => setFieldValue("timeReceived", date)}
            minDate={values.timeLoaded ? values.timeLoaded : new Date()}
          />
          <FormErrorMessage name="timeReceived" />
        </Grid>
        <Grid item xs={12}>
          <PriceField
            label="Sale Price"
            value={values.salePrice}
            onChange={(val) => setFieldValue("salePrice", val)}
          />
        </Grid>
        <Grid item xs={12}>
          <TextField
            fullWidth
            variant="outlined"
            multiline
            rows={3}
            id="notes"
            name="notes"
            label="Notes"
            placeholder="Please enter ticket notes here..."
            onChange={handleChange}
            value={values.notes ? values.notes : ""}
          />
          <FormErrorMessage name="notes" />
        </Grid>
      </Grid>
    </Box>
  );
};

export default UnitedSoilsInformation;
